/**
 * Localstorage erstellen oder aktualisieren
 * @param storageName
 * @param storageValue
 */
export function setLocalStorage(storageName, storageValue, stringify = false) {

    storageValue = JSON.stringify(storageValue);

    localStorage.setItem(storageName, storageValue);

    if (storageName.includes("edit_counter_")) {
        return;
    }

    let edit_counter = localStorage.getItem("edit_counter_" + storageName);
    setLocalStorage("edit_counter_" + storageName, edit_counter !== null ? parseInt(parseInt(edit_counter) + 1) : 1);
}

/**
 * @param {*} storageName
 * @param {*} callbackAPI
 * @returns
 */
export async function getLocalStorageAsync(storageName, callbackAPI) {
    let editCounter = parseInt(localStorage.getItem("edit_counter_" + storageName), 10) || 0;
    let data = null;

    if ((editCounter > 20 || localStorage.getItem(storageName) === null) && typeof callbackAPI === "function") {
        try {
            data = await callbackAPI();
            if (data !== null && data !== undefined) {
                localStorage.setItem(storageName, JSON.stringify(data));
                localStorage.setItem("edit_counter_" + storageName, "0");
            }
        } catch (error) {
            data = null;
            console.error("Error in callbackAPI:", error);
        }
    } else {
        const storageData = localStorage.getItem(storageName);
        if (isJsonString(storageData)) {
            data = JSON.parse(storageData);
        }
    }

    if (data == null) {
        if (localStorage.getItem(storageName) == null) {
            // Data von Api und Localstorage ist null, anlegen leerer localstorage
            data = [];
            setLocalStorage(storageName, data);
        } else {
            // Data von Api null, zurückfallen auf localstorage (warscheinlich api anfrage fehlgeschlagen)
            const storageData = localStorage.getItem(storageName);
            if (isJsonString(storageData)) {
                data = JSON.parse(storageData);
            }
        }
    }

    return data;
}


/**
 * Localstorage lehren
 * @param storageName
 */
export function deleteLocalStorage(storageName) {
    localStorage.removeItem(storageName);
    localStorage.removeItem("edit_counter_" + storageName);
}


/**
 * @param str
 * @returns {boolean}
 */
export function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
